import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { cn } from '@/lib/utils';
import { toggleMobileMenu } from '@/features/ui/sliceMobileMenu';

const GeneralOverlay = () => {
  const dispatch = useDispatch();
  const [isShow, setIsShow] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsShow(true);
    }, 1);
  }, []);

  const closeMenu = () => {
    dispatch(toggleMobileMenu(false));
  };

  return (
    <div
      onClick={closeMenu}
      role="presentation"
      className={cn(
        'absolute block w-full h-full left-0 top-0 cursor-pointer z-[2] bg-transparent transition-all duration-400',
        isShow && 'bg-black/50'
      )}
    />
  );
};

export default GeneralOverlay;
